<template>
  <div class="p-field p-col-12 p-lg-4">
    <AppFormItem label="Tipo" :error="error">
      <TreeSelect
        :modelValue="typeId ? { [typeId]: true } : null"
        @update:modelValue="onUpdate($event)"
        :options="serviceTypes"
      >
        <template #value="props">{{ getValue(props) }}</template>
      </TreeSelect>
    </AppFormItem>
  </div>
</template>

<script>
import { ServiceTypeApi } from '../../../services/api';

export default {
  name: 'ServiceEditType',
  props: {
    error: Object,
    type: Object,
    typeId: {
      type: Number,
      required: false,
      default: null,
    },
    customer: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      serviceTypes: [],
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    customer(newVal, oldVal) {
      if (newVal?.id !== oldVal?.id) {
        this.fetchData();
      }
    },
  },
  methods: {
    onUpdate(event) {
      const typeId = Object.keys(event || {})[0];
      this.$emit('update:typeId', Number(typeId) || null);
    },
    getValue(props) {
      return props?.value?.[0]?.data?.path || this.type?.path || {};
    },
    async fetchData() {
      const serviceTypeResponse = await ServiceTypeApi.fetch(
        {
          sortField: 'path',
          order: 'asc',
          root: true,
        },
        {
          accessToken: this?.customer?.accessToken,
        }
      );
      this.serviceTypes = this.formatTypes(serviceTypeResponse.results);
    },
    formatTypes(types) {
      return types.map((type) => {
        return {
          key: type.id,
          data: type,
          label: type.name,
          children: type?.children?.length
            ? this.formatTypes(type.children)
            : [],
          leaf: !type?.children?.length,
        };
      });
    },
  },
};
</script>

<style>
</style>
